if (!customElements.get('yns-product-carousel')) {
  customElements.define(
    'yns-product-carousel',
    class YnsProductCarousel extends HTMLElement {
      constructor() {
        super();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      connectedCallback() {
        const cards = Array.from(this.querySelectorAll('.yns-product-card-wrap'));

        // Quick Add buttons
        this.querySelectorAll('[data-quick-add]').forEach((btn) => {
          btn.addEventListener('click', (e) => this.handleQuickAdd(e, btn));
        });

        // If reduced motion preference, just reveal all cards immediately
        if (this.reducedMotion) {
          cards.forEach((card) => card.classList.add('is-visible'));
          return;
        }

        // Fade-in observer: one-shot reveal as cards enter viewport
        this.io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.io.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
        );

        cards.forEach((card) => this.io.observe(card));
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }

      handleQuickAdd(event, btn) {
        event.preventDefault();
        event.stopPropagation();
        const variantId = btn.dataset.variantId;
        if (!variantId || btn.dataset.state === 'loading') return;
        btn.dataset.state = 'loading';

        const cartDrawer = document.querySelector('cart-drawer');
        const sections = cartDrawer
          ? ['cart-drawer', 'cart-icon-bubble']
          : ['cart-icon-bubble'];

        fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((res) => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
          })
          .then((data) => {
            btn.dataset.state = 'added';
            if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
              cartDrawer.renderContents(data);
            } else if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
            setTimeout(() => {
              if (btn.dataset.state === 'added') btn.removeAttribute('data-state');
            }, 1500);
          })
          .catch((err) => {
            console.error('Quick add failed:', err);
            btn.removeAttribute('data-state');
          });
      }
    }
  );
}
